module.exports = __webpack_public_path__ + "static/be-hospitaalbroeders-logo-f93f37ec36a6fc6b9929f3b3e98de846.svg";